import styled, { css } from 'styled-components';
import { header2, header4, Text, text1 } from '@ardoq/typography';
import { dashedGrey1, colors, r8, s16, s8 } from '@ardoq/design-tokens';
import { disabledCSS } from '@ardoq/style-helpers';
import { FIELD_SELECTOR, CHECKBOX_SELECTOR } from '@ardoq/forms';
import { BUTTON_SELECTOR } from '@ardoq/button';
import { Align, FlexBox, Justify } from '@ardoq/layout';
import { FORMATTING_RULE_LINE_HEIGHT as LINE_HEIGHT } from './consts';
import { GRID_TEMPLATE_COLUMNS } from './Formattings/PerspectivesConditionalFormatting/consts';

export const HeaderWrapper = styled(FlexBox).attrs({
  justify: 'space-between',
  gap: 'medium',
})`
  ${header2};
  padding: ${s16};

  ${BUTTON_SELECTOR} {
    flex-shrink: 0;
  }
`;

const groupBoxCss = css`
  ${text1};
  padding: ${s16} ${s8};
  border: ${dashedGrey1};
  border-radius: ${r8};

  ${FIELD_SELECTOR} {
    flex: 1;
  }
`;
export const GroupBox = styled(FlexBox).attrs({
  align: 'center',
  gap: 'small',
  flexWrap: true,
})`
  ${groupBoxCss}
`;

export const GroupBoxWarningNotification = styled(GroupBox)`
  min-height: 70px;
  padding-left: 16px;
  justify-content: space-between;
  background-color: ${colors.yellow50};
  border-color: ${colors.yellow950};
  color: ${colors.yellow950};
`;

export const FormattingRuleGroupBox = styled(FlexBox).attrs({
  align: 'center',
  gap: 'small',
  flexWrap: true,
})`
  ${groupBoxCss}

  ${CHECKBOX_SELECTOR} {
    height: ${LINE_HEIGHT}px;
  }
`;

export const ColorRangeValueBox = styled(FormattingRuleGroupBox).attrs({
  padding: 'none',
  minWidth: 'fit-content',
})`
  flex: 2;
  overflow: hidden;
`;

export const RowHeader = styled.div`
  ${header4};
`;

export const MessageContainer = styled.div`
  flex: 1;
`;

export const Header = styled.div`
  ${header4};
  padding-left: ${s16};
`;

export const FlexHeader = styled(Header)`
  flex: 1;
  align-items: center;
`;

type InputsWrapperProps = {
  $isDisabled?: boolean;
  $align?: Align;
  $justify?: Justify;
  $flex?: number;
};

export const InputsWrapper = styled.div.attrs<InputsWrapperProps>(props => ({
  inert: props.$isDisabled,
}))<InputsWrapperProps>`
  display: flex;
  gap: ${s8};
  flex: ${({ $flex }) => $flex || 1};
  align-items: ${({ $align }) => $align || 'center'};
  ${({ $justify }) =>
    $justify &&
    css`
      justify-content: ${$justify};
    `}
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      ${disabledCSS};
      user-select: none;
    `}
`;

export const GridFormattingRuleRow = styled.div`
  ${groupBoxCss}
  display: grid;
  align-items: start;
  grid-template-columns: ${GRID_TEMPLATE_COLUMNS};
  gap: ${s8};
  padding: ${s16} ${s8};

  ${CHECKBOX_SELECTOR} {
    height: ${LINE_HEIGHT}px;
  }
`;

export const GridFullWidthCell = styled.div`
  grid-column: 1 / -1;
`;

export const NumberInputPostfix = styled(Text).attrs({
  variant: 'text2',
  color: 'textSubtle',
})`
  position: absolute;
  top: 50%;
  right: 48px; /* 32px arrow container + 16px spacing */
  transform: translateY(-50%);
  pointer-events: none;
`;
